import { Box } from '@mui/material';
import Loader from 'components/Loader';
import { Procedure } from 'interfaces/procedure';
import React, { ComponentProps } from 'react';

import { ManifestWorkspaceSurface } from './CaseManifestControls';
import { CaseManifestPlanTable } from './CaseManifestPlanTable';
import { CaseManifestSourcePanel } from './CaseManifestSourcePanel';
import { ManifestErrors, ManifestWarnings } from './ManifestFeedback';
import NotEditableSlidesDataGrid from './NotEditableSlidesDataGrid';
import SlideDirectAddSearch from './SlideDirectAddSearch';

interface CaseManifestWorkspaceProps {
  activeSurface: ManifestWorkspaceSurface;
  loadingStatusText: string | null;
  planTableProps: ComponentProps<typeof CaseManifestPlanTable>;
  sourcePanelProps: ComponentProps<typeof CaseManifestSourcePanel>;
  directAddSearchProps: ComponentProps<typeof SlideDirectAddSearch>;
  notIngestedSlides: Procedure[];
  errorMessages: string[];
  warningMessages: string[];
}

export const CaseManifestWorkspace = ({
  activeSurface,
  loadingStatusText,
  planTableProps,
  sourcePanelProps,
  directAddSearchProps,
  notIngestedSlides,
  errorMessages,
  warningMessages,
}: CaseManifestWorkspaceProps) => (
  <>
    {loadingStatusText && (
      <Box mb={1.5}>
        <Loader inline message={loadingStatusText} testId="case-manifest-loading-indicator" />
      </Box>
    )}
    {activeSurface === 'Manifest' ? (
      <CaseManifestPlanTable {...planTableProps} />
    ) : (
      <Box my={1}>
        {activeSurface === 'Cross Lab Search' ? (
          <SlideDirectAddSearch {...directAddSearchProps} />
        ) : activeSurface === 'Not Ingested Slides' ? (
          <NotEditableSlidesDataGrid procedures={notIngestedSlides} />
        ) : activeSurface === 'Lab Lost and Found Slides' || activeSurface === 'Study Lost and Found Slides' ? (
          <CaseManifestSourcePanel {...sourcePanelProps} />
        ) : null}
      </Box>
    )}
    <ManifestErrors messages={errorMessages} />
    <ManifestWarnings messages={warningMessages} />
  </>
);
